// Permite letras (con acentos/ñ), espacios, guiones y apóstrofes. Debe tener al menos una letra.
const NOMBRE_REGEX = /^[\p{L}\p{M} '-]+$/u;

export const esNombreValido = (texto) => {
  if (!texto) return false;
  const trimmed = texto.trim();
  if (trimmed.length === 0) return false;
  return NOMBRE_REGEX.test(trimmed) && /\p{L}/u.test(trimmed);
};
